import CostCenterIcon from "@mui/icons-material/AccountBalanceRounded";
import BreakdownReasonDetailIcon from "@mui/icons-material/DetailsRounded";
import RoleGroupIcon from "@mui/icons-material/AssignmentIndRounded";
import EquipmentIcon from "@mui/icons-material/BuildRounded";
import TodayIcon from "@mui/icons-material/DateRangeRounded";
import BreakdownRootCauseIcon from "@mui/icons-material/ErrorRounded";
import CalendarViewDayIcon from "@mui/icons-material/CalendarViewDayRounded";
import PlantIcon from "@mui/icons-material/HomeWorkRounded";
import AreaIcon from "@mui/icons-material/HorizontalSplitRounded";
import ShiftPlansIcon from "@mui/icons-material/TrackChangesRounded";
import AssignmentIcon from "@mui/icons-material/AssignmentRounded";
import MaintenancePauseReasonIcon from "@mui/icons-material/PauseRounded";
import UserGroupIcon from "@mui/icons-material/PeopleRounded";
import UserIcon from "@mui/icons-material/PersonRounded";
import EquipmentReportIcon from "@mui/icons-material/SettingsBrightnessRounded";
import EquipmentTypeIcon from "@mui/icons-material/SettingsRounded";
import BreakdownReasonPlaceIcon from "@mui/icons-material/PlaceRounded";
import BreakdownReasonGroupIcon from "@mui/icons-material/ViewModuleRounded";
import ListIcon from "@mui/icons-material/ListRounded";
import BreakdownEffectIcon from "@mui/icons-material/WarningRounded";
import MaintenanceTypeIcon from "@mui/icons-material/WorkRounded";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircleRounded";
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import ListAltIcon from "@mui/icons-material/ListAltRounded";
import CheckItemIcon from "@mui/icons-material/FactCheckRounded";
import LocalizationUploadIcon from "@mui/icons-material/TranslateRounded";
import MasterDataIcon from "@mui/icons-material/FileUploadRounded";
import MailGroupsIcon from "@mui/icons-material/MailRounded";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import React, { useState, useEffect } from "react";
import Navbar from "./Navbar/Navbar";
import Sidebar from "./Sidebar/Sidebar";
import { withOktaAuth } from "@okta/okta-react";
import { useDispatch, useSelector } from "react-redux";
import { getUserMenuList } from "../../store/actions/userActions";
import { AssignmentReturned } from "@mui/icons-material";
import PlaylistAddCircleIcon from "@mui/icons-material/PlaylistAddCircle";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';

const NavContainer = ({ authState: { isAuthenticated }, oktaAuth }) => {
    const dispatch = useDispatch();
    const [mainArray, setmainArray] = useState([]);
    const [mailCount, setmailCount] = useState(3);
    const [notificationCount, setnotificationCount] = useState(6);
    const [isSideBarOpen, setisSideBarOpen] = useState(false);
    const [sideBarAnchor, setsideBarAnchor] = useState("left");
    const [sideBarArray, setSideBarArray] = useState([]);
    const [sideBarAreaArray, setSideBarAreaArray] = useState([]);
    const [sideBarBreakdownArray, setSideBarBreakdownArray] = useState([]);
    const [sideBarEquipmentArray, setSideBarEquipmentArray] = useState([]);
    const [sideBarUserArray, setSideBarUserArray] = useState([]);
    const [sideBarPlannedMaintenanceArray, setSideBarPlannedMaintenanceArray] = useState([]);
    const [sideBarAutonomousMaintenanceArray, setSideBarAutonomousMaintenanceArray] = useState([]);
    const [sideBarExcelUploadArray, setSideBarExcelUploadArray] = useState([]);
    const [sideBarMailGroupsArray, setSideBarMailGroupsArray] = useState([]);
    const [userRight, setuserRight] = useState([]);
    const [userInfo, setUserInfo] = useState(null);

    async function checkUser() {
        if (isAuthenticated && !userInfo) {
            const userInfoRes = await oktaAuth.getUserInfo();
            setUserInfo(userInfoRes);
        }
    }

    useEffect(() => {
        const mainArrayVal = [
            {
                name: "Area",
                link: "/area",
                icon: <AreaIcon />,
                code: "area",
                type: "area",
            },
            {
                name: "Plant",
                link: "/plant",
                icon: <PlantIcon />,
                code: "plant",
                type: "area",
            },
            {
                name: "CostCenter",
                link: "/costcenter",
                icon: <CostCenterIcon />,
                code: "costcenter",
                type: "area",
            },
            {
                name: "ShiftPlans",
                link: "/shift-plans",
                icon: <ShiftPlansIcon />,
                code: "shiftPlans",
                type: "area",
            },
            {
                name: "BreakdownGroup",
                link: "/breakdownreasongroup",
                icon: <BreakdownReasonGroupIcon />,
                code: "breakdownreasongroup",
                type: "breakdown",
            },
            {
                name: "BreakdownPlace",
                link: "/breakdownreasonplace",
                icon: <BreakdownReasonPlaceIcon />,
                code: "breakdownreasonplace",
                type: "breakdown",
            },
            {
                name: "BreakdownDetail",
                link: "/breakdownreasondetail",
                icon: <BreakdownReasonDetailIcon />,
                code: "breakdownreasondetail",
                type: "breakdown",
            },
            {
                name: "BreakdownRootCause",
                link: "/breakdownrootcause",
                icon: <BreakdownRootCauseIcon />,
                code: "breakdownrootcause",
                type: "breakdown",
            },
            {
                name: "BreakdownEffect",
                link: "/breakdowneffect",
                icon: <BreakdownEffectIcon />,
                code: "breakdowneffect",
                type: "breakdown",
            },
            {
                name: "MaintenanceType",
                link: "/maintenancetype",
                icon: <MaintenanceTypeIcon />,
                code: "maintenancetype",
                type: "breakdown",
            },
            {
                name: "MaintenancePauseReason",
                link: "/maintenancepausereason",
                icon: <MaintenancePauseReasonIcon />,
                code: "maintenancepausereason",
                type: "breakdown",
            },
            {
                name: "Equipment",
                link: "/equipment",
                icon: <EquipmentIcon />,
                code: "equipment",
                type: "equipment",
            },
            {
                name: "EquipmentType",
                link: "/equipmenttype",
                icon: <EquipmentTypeIcon />,
                code: "equipmenttype",
                type: "equipment",
            },
            {
                name: "EquipmentReportGroup",
                link: "/equipmentreport",
                icon: <EquipmentReportIcon />,
                code: "equipmentreport",
                type: "equipment",
            },
            {
                name: "EkedEquipments",
                link: "/eked-equipment",
                icon: <ConstructionRoundedIcon />,
                code: "ekedEquipment",
                type: "equipment",
            },
            {
                name: "User",
                link: "/users",
                icon: <UserIcon />,
                code: "users",
                type: "user",
            },
            {
                name: "UserGroup",
                link: "/usergroups",
                icon: <UserGroupIcon />,
                code: "usergroups",
                type: "user",
            },
            {
                name: "CheckItemGroup",
                link: "/autonomous-checkitemgroup",
                icon: <CheckItemIcon />,
                code: "autonomous-checkitemgroup",
                type: "autonomousmaintenance",
            },
            {
                name: "RoleGroup",
                link: "/rolegroup",
                icon: <RoleGroupIcon />,
                code: "rolegroup",
                type: "user",
            },
            {
                name: "Pool",
                link: "/pool",
                icon: <ListAltIcon />,
                code: "pool",
                type: "user",
            },
            {
                name: "CheckItemGroup",
                link: "/planned-checkitemgroup",
                icon: <CheckItemIcon />,
                code: "planned-checkitemgroup",
                type: "plannedmaintenance",
            },
            {
                name: "ToBePlanned",
                link: "/to-be-planned",
                icon: <AssignmentIcon />,
                code: "toBePlanned",
                type: "plannedmaintenance",
            },
            {
                name: "MaintenancePlans",
                link: "/planned-maintenance-order-list",
                icon: <AssignmentIcon />,
                code: "plannedmaintenanceorder",
                type: "plannedmaintenance",
            },
            {
                name: "PlannedMaintenanceSchedule",
                link: "/planned-maintenance-calendar",
                icon: <TodayIcon />,
                code: "plannedmaintenancecalender",
                type: "plannedmaintenance",
            },
            {
                name: "BreakdownMaintenanceList",
                link: "/breakdown-list-table",
                icon: <CalendarViewDayIcon />,
                code: "breakdown-list-table",
                type: "plannedmaintenance",
            },
            {
                name: "PlannedMaintenanceTaskListTable",
                link: "/planned-maintenance-task-list-table",
                icon: <ListIcon />,
                code: "pmtasklisttable",
                type: "plannedmaintenance",
            },
            {
                name: "AutonomousMaintenancePlans",
                link: "/autonomous-maintenance-order-list",
                icon: <AssignmentIcon />,
                code: "autonomousMaintenanceOrder",
                type: "autonomousmaintenance",
            },
            {
                name: "AutonomousMaintenanceOrderTaskList",
                link: "/autonomous-maintenance-order-task-list",
                icon: <ListIcon />,
                code: "autonomousMaintenanceOrder",
                type: "autonomousmaintenance",
            },
            {
                name: "MasterDataUpload",
                link: "/masterdata-upload",
                icon: <MasterDataIcon />,
                code: "masterDataUpload",
                type: "excelupload",
            },
            {
                name: "LocalizationDataUpload",
                link: "/localization-upload",
                icon: <LocalizationUploadIcon />,
                code: "localizationDataUpload",
                type: "excelupload",
            },
            {
                name: "PlannedMaintenanceUpdate",
                link: "/planned-maintenance-update",
                icon: <AssignmentReturned />,
                code: "plannedMaintenanceUpdate",
                type: "excelupload",
            },
            {
                name: "SingleMaintenanceUpdate",
                link: "/single-maintenance-update",
                icon: <AssignmentReturned />,
                code: "singleMaintenanceUpdate",
                type: "excelupload",
            },
            {
                name: "CheckItemGroupExcel",
                link: "/check-item-group-excel",
                icon: <PlaylistAddCircleIcon />,
                code: "checkItemGroupExcel",
                type: "excelupload",
            },
            {
                name: "MailGroups",
                link: "/mail-groups",
                icon: <MailGroupsIcon />,
                code: "mailGroups",
                type: "mailgroups",
            },
            {
                name: "PersonnelSummaryList",
                link: "/personnelsummary",
                icon: <SupervisedUserCircleIcon />,
                code: "personnelsummary",
                type: "plannedmaintenance",
            },
            {
                name: "EwoForms",
                link: "/ewoforms",
                icon: <ListAltIcon />,
                code: "ewoForms",
                type: "plannedmaintenance",
            },
            {
                name: "MachineMaintenanceSummaryList",
                link: "/machine-summary-lists",
                icon: <PrecisionManufacturingIcon />,
                code: "machineMaintenanceSummary",
                type: "plannedmaintenance",
            },
            {
                name: "SparePart",
                link: "/spare-part",
                icon: <PublishedWithChangesIcon />,
                code: "sparepart",
                type: "equipment",
            },
            {
                name: "SparePartList",
                link: "/spare-part-list",
                icon: <ManageHistoryIcon />,
                code: "sparepartlist",
                type: "plannedmaintenance",
            },
            {
                name: "SparePartExcel",
                link: "/spare-part-excel",
                icon: <PublishedWithChangesIcon />,
                code: "sparePartExcel",
                type: "excelupload",
            },
            {
                name: "SparePartNoteDefinitions",
                link: "/spare-part-note-definitions",
                icon: <PlaylistAddCircleIcon />,
                code: "sparePartNoteDefinitions",
                type: "equipment",
            },
        ];
        // get sidebar info
        setmainArray([...mainArray, ...mainArrayVal]);
    }, []);

    useEffect(() => {
        if (mainArray?.length > 0) {
            const timer = setTimeout(() => {
                renderSidebar();
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [mainArray]);

    const renderSidebar = () => {
        if (checkUser()) {
            //api request

            setTimeout(() => {
                dispatch(getUserMenuList());
            }, 2000);
        } else {
            setSideBarArray([]);
            setSideBarAreaArray([]);
            setSideBarBreakdownArray([]);
            setSideBarEquipmentArray([]);
            setSideBarUserArray([]);
            setSideBarPlannedMaintenanceArray([]);
            setSideBarAutonomousMaintenanceArray([]);
            setSideBarExcelUploadArray([]);
            setSideBarMailGroupsArray([]);
        }
    };
    const {
        user: { userMenuList },
        user: { userInterfaceList },
    } = useSelector((user) => user);

    useEffect(() => {
        if (userInterfaceList?.resultObject?.interfaceList) {
            const userRightVal = userInterfaceList?.resultObject?.interfaceList.map((item) => item);
            setuserRight([...userRight, ...userRightVal]);
        }
    }, [userInterfaceList]);

    useEffect(() => {
        if (userMenuList?.length) {
            const filterArray = userMenuList?.map((item) => item.code);

            const sidebarArrayVal = mainArray.filter((item) => filterArray.indexOf(item.code) > -1);

            const sidebarAreaArrayVal = sidebarArrayVal.filter((item) => item.type === "area");

            const sidebarBreakdownArrayVal = sidebarArrayVal.filter((item) => item.type === "breakdown");

            const sidebarEquipmentArrayVal = sidebarArrayVal.filter((item) => item.type === "equipment");

            const sidebarUserArrayVal = sidebarArrayVal.filter((item) => item.type === "user");

            const sideBarPlannedMaintenanceArrayVal = sidebarArrayVal.filter((item) => item.type === "plannedmaintenance");

            const sideBarAutonomousMaintenanceArrayVal = sidebarArrayVal.filter((item) => item.type === "autonomousmaintenance");

            const sideBarExcelUploadArrayVal = sidebarArrayVal.filter((item) => item.type === "excelupload");

            const sideBarMailGroupsArrayVal = sidebarArrayVal.filter((item) => item.type === "mailgroups");

            setSideBarArray([...sideBarArray, ...sidebarArrayVal]);
            setSideBarAreaArray([...sideBarAreaArray, ...sidebarAreaArrayVal]);
            setSideBarBreakdownArray([...sideBarBreakdownArray, ...sidebarBreakdownArrayVal]);
            setSideBarEquipmentArray([...sideBarEquipmentArray, ...sidebarEquipmentArrayVal]);
            setSideBarUserArray([...sideBarUserArray, ...sidebarUserArrayVal]);
            setSideBarPlannedMaintenanceArray([...sideBarPlannedMaintenanceArray, ...sideBarPlannedMaintenanceArrayVal]);
            setSideBarAutonomousMaintenanceArray([...sideBarAutonomousMaintenanceArray, ...sideBarAutonomousMaintenanceArrayVal]);
            setSideBarExcelUploadArray([...sideBarExcelUploadArray, ...sideBarExcelUploadArrayVal]);
            setSideBarMailGroupsArray([...sideBarMailGroupsArray, ...sideBarMailGroupsArrayVal]);
        }
    }, [userMenuList]);

    const toggleSideBarHandler = () => setisSideBarOpen(!isSideBarOpen);

    return (
        <React.Fragment>
            <Navbar userRight={userRight} mailCount={mailCount} notificationCount={notificationCount} menuClick={toggleSideBarHandler} />
            <Sidebar
                userRight={userRight}
                shouldOpen={isSideBarOpen}
                anchor={sideBarAnchor}
                sidebarArray={sideBarArray}
                sidebarAreaArray={sideBarAreaArray}
                sidebarBreakdownArray={sideBarBreakdownArray}
                sidebarEquipmentArray={sideBarEquipmentArray}
                sidebarUserArray={sideBarUserArray}
                sideBarPlannedMaintenanceArray={sideBarPlannedMaintenanceArray}
                sideBarAutonomousMaintenanceArray={sideBarAutonomousMaintenanceArray}
                sideBarExcelUploadArray={sideBarExcelUploadArray}
                sideBarMailGroupsArray={sideBarMailGroupsArray}
                onClose={toggleSideBarHandler}
            />
        </React.Fragment>
    );
};

export default withOktaAuth(NavContainer);
